export default __webpack_public_path__ + "static/media/visa.63c28dbd.svg";